module.exports = __webpack_public_path__ + "static/media/pirateDuck.092eddab.png";


//////////////////
// WEBPACK FOOTER
// ./src/pirateDuck.png
// module id = 436
// module chunks = 0